export const SUPPORTED_COMMANDS = [
	"menu",
	"enter",
	"up",
	"left",
	"right",
	"down",
	"escape",
	"set_power_on",
	"set_power_off",
	"set_input_hdmi1",
	"set_input_hdmi2",
] as const

export type ProjectorCommand = (typeof SUPPORTED_COMMANDS)[number]
